import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Row, Col} from 'react-bootstrap'
import {linkFinder} from '../../core/links'
import Box from '../../core/components/Box'
import ContactStream from './ContactStream'
import ContactStats from './ContactStats'
import AddProviderContactModal from './AddProviderContactModal'
import i18n from '../i18n'

class ContactStreamLayout extends Component {
    static propTypes = {
    }

    constructor(props) {
        super(props)

        this.state = {
            opened: false
        }
    }

    _open() {
        this.setState({opened: true})
    }

    _close() {
        this.setState({opened: false})
    }

    render() {
        const {dispatch, _links} = this.props
        const {opened} = this.state

        const newProviderContactBoxTitle = (
            <h3>{i18n.newProviderContact}</h3>
        )

        return (
            <div>
                <Row>
                    <Col sm={4} smPush={8}>
                        <ContactStats />
                        {_links.find(linkFinder('AddProviderContact')) && (
                            <Box
                                status='primary'
                                header={newProviderContactBoxTitle}
                                help='+'
                                onClick={() => this._open()}>
                            </Box>
                        )}
                    </Col>
                    <Col sm={8} smPull={4}>
                        <ContactStream />
                    </Col>
                </Row>
                {_links.find(linkFinder('AddProviderContact')) && opened && (
                    <AddProviderContactModal
                        show={opened}
                        onHide={() => this._close()}/>
                )}
            </div>
        )
    }
}

ContactStreamLayout = connect((state) => ({
    _links: state.provider.contact._links
}))(ContactStreamLayout)

export default ContactStreamLayout


// WEBPACK FOOTER //
// ./lib/provider/components/ContactStreamLayout.js